import { Component, TemplateRef } from '@angular/core';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
  host: { '[class.ngb-toasts]': 'true' }
})
export class AlertsComponent {

  constructor(public toastService: ToastService) { }

  /**
   * Determines if the given toast parameter is a TemplateRef.
   * @param toast - A toast parameter, which can be a string, TemplateRef, or an object containing a 'textOrTpl' property.
   * @returns boolean - Returns 'true' if the toast parameter is a TemplateRef, otherwise returns 'false'.
   */
  public isTemplate(toast: any): boolean {
    if (typeof toast === 'string') {
      return false;
    }

    if (toast instanceof TemplateRef) {
      return true;
    }

    return toast.textOrTpl instanceof TemplateRef;
  }


}
